import React from 'react';

const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M19.41,3.6a2,2,0,0,0-2.85,0L8.05,12.1,3.55,7.59A2.06,2.06,0,1,0,.64,10.51l5.82,5.84a2,2,0,0,0,.71.46,2,2,0,0,0,2.27-.4l10-10A2,2,0,0,0,20,5,2,2,0,0,0,19.41,3.6Z" />
  </svg>
);

export default CheckIcon;
